(() => {
  'use strict';
  if (window.HEIRPieceDetailToggle) return;

  const initialized = new WeakSet();
  let sequence = 0;

  function initializeCard(card) {
    if (initialized.has(card)) return;
    const frame = card.querySelector('.product-card__image');
    const detail = card.querySelector('[data-piece-detail-image]');
    const controls = card.querySelector('[data-piece-detail-controls]');
    const whole = frame?.querySelector('img:not([data-piece-detail-image])');
    const buttons = controls?.querySelectorAll('[data-piece-view]');
    const status = controls?.querySelector('[data-piece-detail-status]');
    if (!frame || !whole || !detail || !controls || !status || buttons.length !== 2 || !detail.dataset.pieceDetailSrc) return;
    initialized.add(card);
    frame.id ||= 'heir-piece-view-' + (++sequence);
    buttons.forEach(button => button.setAttribute('aria-controls', frame.id));

    let requested = 'whole';
    let loaded = false;
    let timer = null;
    const clearTimer = () => { if (timer !== null) clearTimeout(timer); timer = null; };
    const announce = text => { status.textContent = text; };
    const settle = () => {
      clearTimer();
      frame.removeAttribute('aria-busy');
      controls.removeAttribute('data-piece-detail-error');
      announce('');
    };
    const display = view => {
      card.dataset.pieceDetailView = view;
      whole.setAttribute('aria-hidden', String(view === 'detail'));
      detail.hidden = view !== 'detail';
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pieceView === view)));
    };
    const failed = () => {
      if (requested !== 'detail') return;
      requested = 'whole';
      loaded = false;
      settle();
      display('whole');
      controls.setAttribute('data-piece-detail-error', '');
      announce(controls.dataset.errorLabel);
    };
    const ready = () => {
      if (!detail.naturalWidth) return;
      loaded = true;
      if (requested !== 'detail') return;
      settle();
      display('detail');
    };
    detail.addEventListener('load', ready);
    detail.addEventListener('error', failed);
    controls.addEventListener('click', event => {
      const button = event.target.closest('[data-piece-view]');
      if (!button || !controls.contains(button)) return;
      event.preventDefault();
      requested = button.dataset.pieceView === 'detail' ? 'detail' : 'whole';
      settle();
      if (requested === 'whole') {
        display('whole');
        return;
      }
      if (loaded) {
        display('detail');
        return;
      }
      frame.setAttribute('aria-busy', 'true');
      announce(controls.dataset.loadingLabel);
      timer = setTimeout(failed, 15000);
      // No detail request is made before an explicit choice. Keep whole visible
      // until the native image load succeeds; changing back cancels that intent.
      detail.loading = 'eager';
      detail.removeAttribute('src');
      detail.src = detail.dataset.pieceDetailSrc;
      if (detail.complete && detail.naturalWidth > 0) ready();
    });
    card.dataset.pieceDetailReady = '';
    display('whole');
    controls.hidden = false;
  }

  function initialize(scope = document) {
    if (scope.matches?.('[data-piece-detail-card]')) initializeCard(scope);
    scope.querySelectorAll?.('[data-piece-detail-card]').forEach(initializeCard);
  }
  window.HEIRPieceDetailToggle = { initialize };
  const start = () => {
    initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    if (typeof MutationObserver === 'function') {
      const observer = new MutationObserver(records => {
        records.forEach(record => record.addedNodes.forEach(node => {
          if (node.nodeType === 1) initialize(node);
        }));
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
